export default __webpack_public_path__ + "static/media/xpensityv2-lg-2.4cc2432b.webp";